import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/stand-nfc")({
  beforeLoad: () => {
    throw redirect({ href: "/stand-nfc-qr", statusCode: 301 });
  },
});
